import React, { useCallback, useEffect } from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import Socket from "socket";
import eyeUnderline from "assets/images/ct/red-line.png";
import redEye from "assets/images/ct/red-eyes.png";
import tech from "assets/images/ct/tech.png";
import schemes from "assets/images/ct/schemes.png";
import random from "assets/images/ct/random.png";
import mythos from "assets/images/ct/mythos.png";
import aliens from "assets/images/ct/aliens.png";
import OtherPlayer from "./OtherPlayer";
import { useDispatch } from "react-redux";
import { set_ct_dice_special6 } from "redux/game/action";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";

const OtherPlayerDicespecial6 = ({
  currentPlayerCard,
  roomId,
  currentPlayer,
  showCardList,
  currentPlayerInfo
}) => {
  const dispatch = useDispatch();
  const isPlayerhasCard = Object.entries(currentPlayerCard?.cards).some(
    (value, index) => {
      return value[1] > 0;
    }
  );

  const cardImageFunction = (type) => {
    switch (type) {
      case "tech":
        return tech;
      case "mythos":
        return mythos;
      case "aliens":
        return aliens;
      case "random":
        return random;
      default:
        return schemes;
    }
  };
  const handleShowCardList = () => {
    dispatch(set_ct_dice_special6(true));
  };

  const cardPressAction = (card) => {
    const data = {
      action: "special-action",
      roomId,
      playerId: currentPlayer?.player_id,
      specialAction: "Discard",
      string: card
    };
    Socket.sendMessage(data);
  };

  const handleCardPress = useCallback(
    _.debounce((card) => cardPressAction(card), 1000, {
      leading: true,
      trailing: false
    }),
    [roomId]
  );

  useEffect(() => {
    return Socket.addListener("special-action", handleShowCardList);
  }, []);

  return (
    <>
      {showCardList ? (
        <OtherPlayer
          currentPlayerInfo={currentPlayerInfo}
          currentPlayerCard={currentPlayerCard}
        />
      ) : (
        <motion.div
          variants={divVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          className="double-dice-wrapper"
        >
          <div className="other-player">
            <div className="text-center">
              <motion.img
                variants={fadeVariants}
                src={redEye}
                className="img-fluid image"
                alt="grayEye"
              />
              <motion.h2 variants={fadeVariants} className="heading">
                {"ARMAGEDDON"}
              </motion.h2>
              <motion.img
                variants={fadeVariants}
                src={eyeUnderline}
                className="img-fluid red-line"
                alt=""
              />
              <motion.p variants={fadeVariants} className="desc">
                {isPlayerhasCard
                  ? "Armageddon is upon us. Choose a card to discard "
                  : "Armageddon is upon us, but you've got nothing to lose"}
              </motion.p>

              {isPlayerhasCard && (
                <div className="high-five-wrapper" style={{ width: "100%" }}>
                  <div className="high-cards-flex">
                    {Object.entries(currentPlayerCard?.cards).map(
                      (value, index) => (
                        <React.Fragment key={index}>
                          {value[1] > 0 && (
                            <motion.div
                              variants={staticBounceVariants}
                              onClick={() => handleCardPress(value[0])}
                              className="card"
                              style={{ width: "38%" }}
                            >
                              <img
                                src={cardImageFunction(value[0])}
                                className="img-fluid"
                                alt=""
                              />
                              {value[1] > 1 && (
                                <img
                                  src={cardImageFunction(value[0])}
                                  className="img-fluid img1"
                                  alt=""
                                />
                              )}
                            </motion.div>
                          )}
                        </React.Fragment>
                      )
                    )}
                  </div>
                </div>
              )}
            </div>
            {!isPlayerhasCard && (
              <motion.div
                variants={staticBounceVariants}
                className="text-right mr-4"
              >
                <button
                  onClick={() => handleShowCardList()}
                  className="ct-btn-green px-5 confirm-btn"
                  style={{
                    width: "auto",
                    padding: "8px 18px 10px 18px",
                    fontSize: "16px"
                  }}
                >
                  CONFIRM
                </button>
              </motion.div>
            )}
          </div>
        </motion.div>
      )}
    </>
  );
};

export default OtherPlayerDicespecial6;
